<app-banner [heading]="'YOGA ROOM'" [detail]="'ACHIEVING HIGH STANDARDS'"></app-banner>

<main id="main">
   
    
    <!-- ======= Features Section ======= -->
    <section id="features" class="features">
      <div class="container">

        <div class="row feature-item">
          <div class="col-lg-6 " >
            <img src="assets/img/infra/yogaroom/1.jpg" class="img-fluid" alt="">
          </div>
          <div class="col-lg-6  pt-5 pt-lg-0" >
            <h4>Healthy Body- Healthy Mind</h4>
            <p>
              TGS follows holistic approach to education that seeks to fully activate all aspects of the learners personality.
			  So Yoga is on the daily schedule.Each morning  every classroom begins the day with a "Be Well "discussion,helping
			  students in preparing for the learning time.Participating in yoga and mindfulness activities at school helps relieve
			  stress and anxiety in young children,improving their well being and emotional health.The curriculum for yoga has been 
			  designed in such a way that it has both theoretical and practical content on the pattern of physical education.
			  
            </p>
			
          </div>
		   <div class="col-lg-6 " >
            <img src="assets/img/infra/yogaroom/2.jpg" class="img-fluid" alt="">
          </div>
		   <div class="col-lg-6 " >
            <img src="assets/img/infra/yogaroom/3.jpg" class="img-fluid" alt="">
          </div>
		 
        </div>
      </div>
    </section><!-- End Features Section -->
	
	
	
    
    
  </main>